import { useState, useEffect, useContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PedidosHistorialFormContext } from '../../../context/pedidoshistorial/PedidosHistorialContext';
import { PedidosHistorialDetalleState } from '../../../context/pedidoshistorialdetalle/PedidosHistorialDetalleState';
import DatatableDetalle from './pedidosHistorialDet/DatatableDetalle';
import FormButtons from "../../../components/FormButtons/FormButtons";
import FormField from "../../../components/FormField/FormField";
import Inputs from "./configForm/inputs";
import { formatDateTime } from "../../../helpers/dateUtils";
import ModalObs from "./modalObsFP/modalObs";
import { Grid, Typography, Box, Button } from '@mui/material';
import DatosPagoCliente from "./modalObsFP/DatosPagoCliente";

const nameData = "pedidoshistorial";
export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { report } = useContext(PedidosHistorialFormContext);
  const [openModal, setOpenModal] = useState(false);
  const [datosCli, setDatosCli] = useState({});
  // Navigate to datagrid
  const navigate = useNavigate();
  // Manejo De Fechas
  const formatDateMemoized = useCallback(formatDateTime, []);

  useEffect(() => {
    console.log("report", report);
    if (report) {
      setForm({
        ...report,
      createdAt: report.createdAt ? formatDateMemoized(report.createdAt) : "",
      ord_mobile_creation_date: report.ord_mobile_creation_date ? formatDateMemoized(report.ord_mobile_creation_date) : "",
      
        razon_social:
          report.cli_id === 1
            ? "Consumidor Final"
            : report.razon_social?.trim()
              ? report.razon_social
              : "",
        cli_name:
          report.cli_id === 1
            ? "Consumidor Final"
            : report.cli_name?.trim()
              ? report.cli_name
              : "",

        cli_categoria:
          report.cli_categoria === 0 ? "Mayorista" :
            report.cli_categoria === 1 ? "Minorista" :
              report.cli_categoria === 2 ? "Costo" : "Sin definir",
        cli_direccion: report.cli_direccion
          ? [
            report.cli_direccion,
            report.cli_nro_calle,
            report.cli_piso ? `Piso ${report.cli_piso}` : null,
            report.cli_dpto ? `Dpto ${report.cli_dpto}` : null,
          ]
            .filter(Boolean)
            .join(" ")
          : "No disponible",
        sel_name: report.sel_id === null
          ? "Página Web"
          : (report?.empleado_ord_his?.sel_lastname?.trim() || report?.empleado_ord_his?.sel_firstname?.trim())
            ? report?.empleado_ord_his?.sel_lastname + ", " + report?.empleado_ord_his?.sel_firstname
            : "Nombre No Disponible",

        ord_pago_estado:
          report.ord_pago_estado === 0 ? "Pago en Lordl" :
            report.ord_pago_estado === 1 ? "Transferencia" :
              report.ord_pago_estado === 2 ? "Mercado Pago" : "Sin definir",

        ord_state: report.ord_state,

        desc_descripcion: report.id_desc === 0 ? "Descuento Aplicado por Preventista" :
          report.desc_descripcion || "No se aplicó descuento",

      });
      if (report.ord_datos_cli) {
        try {
          const datosParseados = JSON.parse(report.ord_datos_cli);
          const datosSinMercadoPago = Object.fromEntries(
            Object.entries(datosParseados).filter(([key]) => key !== "mercadopago")
          );

          setDatosCli(datosSinMercadoPago);
        } catch (error) {
          console.error("Error parsing ord_datos_cli:", error);
          setDatosCli({});
        }
      }
    }

  }, [report, formatDateMemoized]);

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  const hayDatosCli = datosCli.nombre;

  const camposFormulario = Inputs.map((input) => {
    if (input.name === "ord_datos_cli") {
      return hayDatosCli ? (
        <div key={input.name} className="formField">
          <label>Datos Del Pago</label>
          <Button type="button"
            onClick={() => setOpenModal(true)}
            sx={{
              backgroundColor: '#1976d2 !important',
              color: '#fff !important',
              padding: '8px 24px !important',
              borderRadius: '8px !important',
              marginLeft: '10px !important',
              boxShadow: 'none !important',
              '&:hover': {
                backgroundColor: '#115293 !important',
              },
            }}>
            Ver
          </Button>
        </div>
      ) : null;
    }

    return (
      <FormField
        key={input.name}
        input={input}
        value={form[input.name]}
      />
    );
  });

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, ' $1');

  const contenidoModal = datosCli && Object.keys(datosCli).length > 0 ? (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        {Object.entries(datosCli).flatMap(([key, value]) => {
          // Mostrar "Pagado con Mercado Pago"
          if (key === "mercadoPago" && value === true) {
            return (
              <Grid item xs={6} md={6} key={key}>
                <Typography variant="body2">
                  <strong>Estado de pago:</strong> Pagado con Mercado Pago
                </Typography>
              </Grid>
            );
          }

          // Desglosar objetos como "pago"
          if (typeof value === 'object' && value !== null) {
            return Object.entries(value).flatMap(([subKey, subValue]) => {
              // Mostrar "Dinero en cuenta" si medioPago === "account_money"
              if (subKey === "medioPago" && subValue === "account_money") {
                return (
                  <Grid item xs={6} md={6} key={`${key}.${subKey}`}>
                    <Typography variant="body2">
                      <strong>Medio de Pago:</strong> Dinero en cuenta
                    </Typography>
                  </Grid>
                );
              }

              // Ocultar tarjeta y cuotas si medioPago === "account_money"
              if (
                (subKey === "Tarjeta" || subKey === "cuotas") &&
                value["medioPago"] === "account_money"
              ) {
                return null;
              }

              return (
                <Grid item xs={6} md={6} key={`${key}.${subKey}`}>
                  <Typography variant="body2">
                    <strong>{capitalize(subKey)}:</strong> {subValue ?? "No disponible"}
                  </Typography>
                </Grid>
              );
            });
          }

          // Valores normales
          return (
            <Grid item xs={6} md={6} key={key}>
              <Typography variant="body2">
                <strong>{capitalize(key)}:</strong> {value ?? "No disponible"}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ) : (
    <Typography>No hay datos para mostrar.</Typography>
  );

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {camposFormulario}

            </form>
            <FormButtons
              handleCancel={handleCancel}
              cancelText="Volver"
              showSaveButton={false}
            />
            <PedidosHistorialDetalleState>
              <DatatableDetalle
                pedidoid={report.ord_id}
              />
            </PedidosHistorialDetalleState>
            {openModal && (
              <ModalObs onClose={() => setOpenModal(false)} title="Datos del pedido">
                <div className="modalContent">
                  <DatosPagoCliente datosCli={datosCli} />
                </div>
              </ModalObs>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
